/**
 * Warns about unhandled XState events via `console.warn`. Add as a `'*'`
 * wildcard handler at the root of each machine.
 *
 * Mirrors the helper that already ships in eco-tools'
 * `frontend/packages/{project-area,protected-areas}/src/{utils,shared/utils}/xstate-utils.ts`
 * so machines feel the same on either side of the monorepo.
 */
export function warnUnhandledEvent(machineId: string, eventType: string): void {
  console.warn(`[${machineId}] Unhandled event: ${eventType}\n`, new Error().stack);
}
